/**
 * Case-insensitive string compare for visible labels (dropdown text, metro names, etc.).
 */
export function compareLabels(a: string, b: string): number {
  return a.localeCompare(b, undefined, { sensitivity: 'base' });
}

export function sortByLabel<T>(items: readonly T[], getLabel: (item: T) => string): T[] {
  return [...items].sort((x, y) => compareLabels(getLabel(x), getLabel(y)));
}

/** Region rows from `/admin/regions`: sort by metro display name, then `region_name`. */
export interface RegionSortable {
  region_name: string;
  metro_name?: string;
}

export function sortRegions<T extends RegionSortable>(regions: readonly T[]): T[] {
  return [...regions].sort((a, b) => {
    const labelA = (a.metro_name ?? a.region_name).trim();
    const labelB = (b.metro_name ?? b.region_name).trim();
    const byMetro = compareLabels(labelA, labelB);
    if (byMetro !== 0) return byMetro;
    return compareLabels(a.region_name, b.region_name);
  });
}
